import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import downloadRecording from '../../helpers/downloadRecording';
import { RecordingSource } from '../../helpers/enums';
import sanitize from '../../helpers/sanitize';

const dateFormat = 'YYYY-MM-DD h-mm-ss a';
const label = 'Download video for playback (mp4)';

export default function useDownloadRaw({
  namingConvention,
  outfile,
  file,
  m3u8Url,
  title,
  name,
  createdAt,
  durationMillis,
  startedAt,
  newTitle,
  durationSeconds,
}) {
  const [recordingLink, setRecordingLink] = useState('');
  const [fileName, setFileName] = useState('');
  const [downloadRawOption, setDownloadRawOption] = useState([{}]);

  const [eventName, setEventName] = useState('Download recording');
  const [downloadDuration, setDownloadDuration] = useState(durationSeconds || null);
  useEffect(() => {
    let oldDownloadURL = '';
    if (namingConvention === RecordingSource.HOST || namingConvention === RecordingSource.GUEST) {
      if (outfile && outfile !== null) {
        oldDownloadURL = new URL(outfile);
      } else {
        oldDownloadURL = m3u8Url;
      }
      if (outfile && outfile.includes('sl-recording-clips')) {
        const downloadUrl = new URL(window.CONFIG.recordingClipsDownloadUrl);
        oldDownloadURL.hostname = downloadUrl.host;
      }
      setRecordingLink(oldDownloadURL.href);
    } else {
      if (file) {
        oldDownloadURL = new URL(file);
      }
      if (file && file.includes('cc-video-processed')) {
        const downloadUrl = new URL(window.CONFIG.assetDownloadUrl);
        oldDownloadURL.hostname = downloadUrl.host;
      }
      setRecordingLink(oldDownloadURL.href);
    }
  }, [namingConvention, outfile, file, m3u8Url]);

  useEffect(() => {
    switch (namingConvention) {
      case RecordingSource.HOST:
        setFileName(`${newTitle || title} - Host - ${name} - ${moment(startedAt).format(dateFormat)}.mp4`);
        break;
      case RecordingSource.GUEST:
        setFileName(`${newTitle || title} - Guest - ${name} - ${moment(startedAt).format(dateFormat)}.mp4`);
        break;
      case RecordingSource.CLIPS:
        setFileName(`${newTitle || title} - ${name} - ${moment(createdAt).format(dateFormat)}.mp4`);
        setEventName('Download clip');
        setDownloadDuration(durationMillis ? durationMillis / 1000 : null);
        break;
      default:
        setFileName(`${title}`);
    }
  }, [namingConvention, newTitle, createdAt, durationMillis, name, startedAt, title]);

  const downloadRawRecording = useCallback(
    () => downloadRecording(`${recordingLink}?filename=${encodeURIComponent(sanitize(fileName))}`),
    [recordingLink, fileName]
  );

  useEffect(() => {
    setDownloadRawOption([{ label, onClick: downloadRawRecording }]);
  }, [downloadRawRecording]);

  return { downloadRawOption, eventName, downloadDuration, downloadRawRecording };
}
